import { render, staticRenderFns } from "./HxeNearestChangguanZhanhuiInfoBlock.vue?vue&type=template&id=2dd43ac1&scoped=true"
import script from "./HxeNearestChangguanZhanhuiInfoBlock.vue?vue&type=script&lang=js"
export * from "./HxeNearestChangguanZhanhuiInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd43ac1",
  null
  
)

export default component.exports